<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{pageTitle}}</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">          
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="role.roleName" class="form-control" autocomplete="off" :placeholder="[[roleDisplayHolder]]" required>
              </div>
            </div>
          </div>

          <div class="form-group">
            <ul>
              <li v-for="func in this.functions" :key="func.functionCode">                
                <div class="row">
                  <div class="col-4">
                    <label>{{func.functionCode}}</label>
                  </div>
                  <!-- <div class="col-4">
                    <input :name="func.functionCode" :id="func.functionCode+'True'" type="radio" :value="func.id" @change="functionChanged(func.id, true)">
                    <label :for="func.functionCode+'True'" class="radio-label">利用可能</label>
                  </div>
                  <div class="col-4">
                    <input :name="func.functionCode" :id="func.functionCode+'False'" type="radio" value="" @change="functionChanged(func.id, false)">
                    <label :for="func.functionCode+'False'" class="radio-label">利用不可能</label>
                  </div> -->
                  <div class="col-4">
                    <input :name="func.functionCode" :id="func.functionCode+'True'" type="checkbox" :value="func.id" v-model="functionIdList">
                    <label :for="func.functionCode+'True'" class="radio-label">利用する</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      functions:[],
      functionIdList:[],
      message: '',
      role: {
        roleName: '',
      }
    }
  },
  computed: {
    isSuper: function () {
      return Number(this.$store.state.user.privilege) === authority.isSuper
    },
    isMessage: function () {
      return this.message.length > 0
    },
    pageTitle: function (){
      return '追加機能権限新規登録'
    },    
    roleDisplayHolder:function (){
      return '追加機能権限名（必須）'
    }
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        axios.get("/api/function/list", {
          headers: this.headers(accessToken)
        }).then(response => {
          this.functions = response.data.data.functions
        }).catch(err => {
          this.message = err.message
        })
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.post("/api/role/", {
            role: this.role,
            hospitalId: this.$store.getters.hospital.id,
            functionIdList: this.functionIdList.sort((a,b) => a-b)
          },{
            headers: this.headers(accessToken)
          }).then((response) => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/role/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch(err => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/role/index'))
    },
    functionChanged(id, isTrue){
      if (isTrue){
        this.functionIdList.push(id);
      }
      else{
        var index = this.functionIdList.indexOf(id);
        if (index > -1)
          this.functionIdList.splice(index, 1);
      }
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>